<template>
  <span v-if="templateArgs.data.show">
    <a role="button" class="k-button k-button-icontext filter-clear" href="#" @click="buttonClick">
      <span class="k-icon k-i-plus"></span>
      Select
    </a>
  </span>
</template>

<script>
export default {
  name: "template1",
  methods: {
    buttonClick: function (e) {
      e.preventDefault();
      this.templateArgs.callback()
    }
  },
  data() {
    return {
      templateArgs: {
        callback: function () { },
        data: {
          show: false
        }
      }
    };
  }
};
</script>